// extracted by mini-css-extract-plugin
export default {"button":"Button_button__dXAUs","startIcon":"Button_startIcon__IR6eA","endIcon":"Button_endIcon__N6ITX"};